import { combineReducers } from "redux";
import authReducer from "./Auth.reducer";
import batchReducer from "./Batch.reducer";
import gradeReducer from "./Grade.reducer";
import shiftReducer from "./Shift.reducer";
import studentReducer from "./Student.reducer";
import subjectReducer from "./Subject.reducer";
import terminalSubjectReducer from "./TerminalSubject.reducer";
import individualTerminalAssessmentReducer from "./IndividualTerminalAssessment.reducer";
import terminalAssessmentRankingReducer from "./TerminalAssessmentRanking.reducer";
import featureReducer from "./Feature.reducer";
import weeklyFileReducer from "./WeeklyFiles.reducer";

const reducer = combineReducers({
  auth: authReducer,
  grade: gradeReducer,
  shift: shiftReducer,
  batch: batchReducer,
  student: studentReducer,
  subject: subjectReducer,
  terminalSubject: terminalSubjectReducer,
  individualTerminalAssessment: individualTerminalAssessmentReducer,
  terminalAssessmentRanking: terminalAssessmentRankingReducer,
  feature: featureReducer,
  weeklyFile: weeklyFileReducer,
});

export default reducer;
